import axios from "axios";
import { createHeadersAdmin } from "../../utils/Utils";
import { BASE_URL } from "../../assets/constants/constants";

// FAQ API
export const createFaqAPI = async (data) => {
    const headers = createHeadersAdmin()
    return await axios.post(`${BASE_URL()}add-faq`, data, headers);
};
export const listFaqAPI = async (data) => {
    const headers = createHeadersAdmin()
    return await axios.post(`${BASE_URL()}get-faq-list`, data, headers);
};
export const updateFaqAPI = async (data) => {
    const headers = createHeadersAdmin()
    return await axios.post(`${BASE_URL()}update-faq`, data, headers);
};

export const updateFaqStatusAPI = async (data) => {
    const headers = createHeadersAdmin()
    return await axios.post(`${BASE_URL()}update-faq-status`, data, headers);
};

export const statusUpdateInfoAboutAPI = async (data) => {
    const headers = createHeadersAdmin()
    return await axios.post(`${BASE_URL()}update-infoAbout-status`, data, headers);
};